module.exports = __webpack_public_path__ + "static/img/6.bd98d60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/6.jpg
// module id = m0Rh
// module chunks = 16